import { RouteComponentProps } from 'react-router';
import { dashboardViewRole, priceMonitoringViewRole, UserModel } from '../../api/authentication/authentication.types';
import React, { PropsWithChildren } from 'react';
import { AppState } from '../../store/store.types';
import { connect } from 'react-redux';
import Reports from './view/Reports';
import { SupplierModel } from '../../api/admin/admin.types';
import ConditionalRoute from '../../components/routes/ConditionalRoute';

interface ReportsEntryProps extends RouteComponentProps {
  user: UserModel;
  supplier: SupplierModel;
}

class ReportsEntry extends React.PureComponent<PropsWithChildren<ReportsEntryProps>> {
  render() {
    return (
      <>
        {this.props.children}
        {this.props.supplier.tableauBillingUrl !== null && this.props.supplier.tableauBillingUrl !== undefined && (
          <ConditionalRoute
            acceptedRoles={dashboardViewRole}
            exact
            path={`${this.props.match.path}/billing`}
            render={(routeProps) => <Reports {...routeProps} url={this.props.supplier.tableauBillingUrl}/>}
          />
        )}
        {this.props.supplier.tableauInsightsUrl !== null && this.props.supplier.tableauInsightsUrl !== undefined && (
          <ConditionalRoute
            acceptedRoles={dashboardViewRole}
            exact
            path={`${this.props.match.path}/insights`}
            render={(routeProps) => <Reports {...routeProps} url={this.props.supplier.tableauInsightsUrl}/>}
          />
        )}
        <ConditionalRoute
          acceptedRoles={dashboardViewRole}
          exact
          path={`${this.props.match.path}/price-monitoring`}
          render={(routeProps) => <Reports {...routeProps} url="https://dub01.online.tableau.com/t/rcdashboards/views/PricemonitoringPOC/Brokermarkup"/>}
        />
      </>
    );
  }
}

const subnav = [
  {
    title: 'm2.insights',
    route: '/reports/insights',
    roles: dashboardViewRole
  },
  {
    title: 'm2.billing',
    route: '/reports/billing',
    roles: dashboardViewRole
  },
  {
    title: 'm2.price_monitoring',
    route: '/reports/price-monitoring',
    roles: priceMonitoringViewRole
  }
];


const mapStateToProps = (state: AppState) => ({
  user: state.authentication.user,
  supplier: state.authentication.activeSupplier
});

const reportsEntry = connect(mapStateToProps, null)(ReportsEntry);

export default {
  reportsEntry,
  subnav
};